//no-unused-vars
import React, {Component} from 'react';

function AddAbstractDeadlineToUserCallendar() {
  return "-";
}

export default {AddAbstractDeadlineToUserCallendar}